import React from 'react';
import './WeaponOptions.css';
import ButtonGroup from '../utils/ButtonGroup';
import MediaImg from '../utils/MediaImg';
import {
    WEAPON_SORT_LEVEL,
    WEAPON_SORT_DAMAGE,
    WEAPON_SORT_DAMAGE_PER_AP,
} from '../../core/weaponDamage';

// The slot being edited, not the crossed swords of the weapon *type* group in
// the filters row above — two glyphs so the section name never reads as another
// filter button.
const WEAPON_ICON = '/img/slot_arme.png';

const TXT_TITLE = { fr: 'Armes', en: 'Weapons', de: 'Waffen', es: 'Armas', pt: 'Armas' };

const TXT_DAMAGE = { fr: 'Dégâts', en: 'Damage', de: 'Schaden', es: 'Daños', pt: 'Danos' };
const TXT_DICE = { fr: 'Base', en: 'Base', de: 'Basis', es: 'Base', pt: 'Base' };
const TXT_ON_BUILD = { fr: 'Calculés', en: 'Computed', de: 'Berechnet', es: 'Calculados', pt: 'Calculados' };

const TXT_SORT = { fr: 'Tri', en: 'Sort', de: 'Sortierung', es: 'Orden', pt: 'Ordem' };
const TXT_SORT_LEVEL = { fr: 'Niveau', en: 'Level', de: 'Stufe', es: 'Nivel', pt: 'Nível' };
const TXT_SORT_DAMAGE = { fr: 'Dégâts / tour', en: 'Damage / turn', de: 'Schaden / Zug', es: 'Daños / turno', pt: 'Danos / turno' };
const TXT_SORT_DAMAGE_PER_AP = { fr: 'Dégâts / PA', en: 'Damage / AP', de: 'Schaden / AP', es: 'Daños / PA', pt: 'Danos / PA' };

const t = (dict, lang) => dict[lang] || dict.en;

/**
 * The settings that only mean something while browsing weapons, kept together
 * on one row instead of scattered as loose checkboxes.
 *
 * Damage display and sort are deliberately independent: the ordering is computed
 * from the build's sheet either way, so reading the dice while ranking by output
 * is a coherent thing to want, and coupling them would mean one control silently
 * moving the other.
 */
const WeaponOptions = ({ lang = 'fr', damageOnBuild, onDamageOnBuildChange, sort, onSortChange }) => (
    <div className="weapon-options">
        <h6 className="weapon-options-title">
            <MediaImg
                src={WEAPON_ICON}
                alt=""
                className="weapon-options-title-icon"
                fallback=""
            />
            {t(TXT_TITLE, lang)}
        </h6>

        <div className="weapon-options-group">
            <span className="weapon-options-label">{t(TXT_DAMAGE, lang)}</span>
            <ButtonGroup
                className="weapon-options-choice"
                ariaLabel={t(TXT_DAMAGE, lang)}
                value={damageOnBuild}
                onChange={onDamageOnBuildChange}
                items={[
                    { value: false, label: t(TXT_DICE, lang) },
                    { value: true, label: t(TXT_ON_BUILD, lang) },
                ]}
            />
        </div>

        <div className="weapon-options-group">
            <span className="weapon-options-label">{t(TXT_SORT, lang)}</span>
            <ButtonGroup
                className="weapon-options-choice"
                ariaLabel={t(TXT_SORT, lang)}
                value={sort}
                onChange={onSortChange}
                items={[
                    { value: WEAPON_SORT_LEVEL, label: t(TXT_SORT_LEVEL, lang) },
                    { value: WEAPON_SORT_DAMAGE, label: t(TXT_SORT_DAMAGE, lang) },
                    { value: WEAPON_SORT_DAMAGE_PER_AP, label: t(TXT_SORT_DAMAGE_PER_AP, lang) },
                ]}
            />
        </div>
    </div>
);

export default WeaponOptions;
